import { Mail, Phone, MapPin, Download } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Why Us", href: "#why" },
    { label: "Process", href: "#process" },
    { label: "Contact", href: "#contact" }
];

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-primary text-primary-foreground">
            <div className="container-px mx-auto max-w-7xl py-14 lg:py-16">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <Logo variant="light" />
                        <p className="mt-5 text-sm leading-relaxed text-primary-foreground/70 max-w-md">
                            Zaroor Global Trading LLC is a US-registered wholesale, Amazon sourcing
                            and procurement company founded in 2026. We help businesses worldwide
                            find, verify and work with reliable suppliers — built on trust,
                            transparency and direct communication.
                        </p>
                    </div>

                    <div className="lg:col-span-3">
                        <p className="text-[11px] uppercase tracking-[0.18em] text-primary-foreground/60 font-medium">
                            Navigate
                        </p>
                        <ul className="mt-4 flex flex-col gap-2.5">
                            {LINKS.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        className="text-sm text-primary-foreground/85 hover:text-primary-foreground transition-smooth"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <p className="text-[11px] uppercase tracking-[0.18em] text-primary-foreground/60 font-medium">
                            Contact
                        </p>
                        <ul className="mt-4 flex flex-col gap-3">
                            <li className="flex items-start gap-3 text-sm text-primary-foreground/85">
                                <Mail className="w-4 h-4 mt-0.5 text-primary-foreground/60" />
                                <a href="mailto:info@zaroorglobaltrading.com" className="hover:text-primary-foreground transition-smooth">
                                    info@zaroorglobaltrading.com
                                </a>
                            </li>
                            <li className="flex items-start gap-3 text-sm text-primary-foreground/85">
                                <Phone className="w-4 h-4 mt-0.5 text-primary-foreground/60" />
                                <a href="tel:+13072138513" className="hover:text-primary-foreground transition-smooth">
                                    +1 (307) 213-8513
                                </a>
                            </li>
                            <li className="flex items-start gap-3 text-sm text-primary-foreground/85">
                                <MapPin className="w-4 h-4 mt-0.5 text-primary-foreground/60" />
                                <span>5830 E 2nd St, STE 7000 #34793, Casper, WY 82609, USA</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-primary-foreground/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
                    <p className="text-xs text-primary-foreground/60">
                        © {year} Zaroor Global Trading LLC. All rights reserved.
                    </p>
                    <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
                        <a
                            href="/brand/zaroor-brand-assets.zip"
                            download
                            className="inline-flex items-center gap-1.5 text-xs text-primary-foreground/60 hover:text-primary-foreground transition-smooth"
                            data-testid="footer-brand-assets-download"
                        >
                            <Download className="w-3.5 h-3.5" />
                            Brand assets
                        </a>
                        <p className="text-xs text-primary-foreground/60">
                            Founded 2026 · US-registered B2B wholesale trader
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
